import React, { FC } from 'react'

import './ClientError.scss'
import ooofImg from 'assets/images/404-ooof.svg'
import leftImg from 'assets/images/404-character-1.svg'
import rightImg from 'assets/images/404-character-2.svg'

const ClientError: FC = () => {
  return (
    <div className="sbx-row client-error">
      <img className="client-error__img client-error__img--left" src={leftImg} alt="left rocker" />
      <img className="client-error__img client-error__img--right" src={rightImg} alt="right rocker" />
      <img className="client-error__center-img" src={ooofImg} alt="ooof!" />
    </div>
  )
}

export default ClientError
